export default __webpack_public_path__ + "static/media/icon.a2f71c4a.png";